import { render } from "./abertura _de_embalagem.vue?vue&type=template&id=747852a4"
import script from "./abertura _de_embalagem.vue?vue&type=script&lang=js"
export * from "./abertura _de_embalagem.vue?vue&type=script&lang=js"

import "./abertura _de_embalagem.vue?vue&type=style&index=0&id=747852a4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__